import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function RescheduleModal({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
}) {

    const methods = useForm({
        defaultValues: {
            reschedule_reason: '',
            date: moment().format('YYYY-MM-DD'),
            time: moment().format('HH:mm'),
        }
    });
    const { control, formState: { errors }, handleSubmit } = methods;
    const [isLoading, setIsLoading] = useState(false);
    

    useEffect(() => {

        methods.reset({ reschedule_reason: '' })

    }, [isOpen])



    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form action="" onSubmit={handleSubmit((data) => {
                    setIsLoading(true);
                    onConfirm(data, "reschedule", () => {
                        setIsLoading(false);
                    })
                })}>
                    <ModalHeader className='header_modal align-items-center'>
                        <h5 className="modal-title_u">Do Not Cover Appointment</h5>
                    </ModalHeader>
                    <ModalBody className='modal_form_body'>
                        <div className='step_cards step_1'>
                            <h2>Appointment ID: {appointmentId}</h2>
                            {/* DATE & TIME INPUTS */}
                            <div className="row-primary row-r">
                                <div className="date">
                                    <h2>Date*</h2>
                                    <Controller
                                        name="date"
                                        control={control}
                                        rules={{
                                            required: "Please select date"
                                        }}
                                        render={({ field }) =>
                                            <>
                                                <div className="input-image">
                                                    <input id='date' type="date" name='date' placeholder='Date' required
                                                        {...field}
                                                        value={field.value ? moment(field.value).format('YYYY-MM-DD') : ""}
                                                        onChange={(e) => {
                                                            const dateString = moment((e.target.value)).format('YYYY-MM-DD')
                                                            field.onChange(dateString)
                                                        }}
                                                    />
                                                    <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />

                                                </div>
                                                {errors?.date?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.date?.message} />
                                                    </div>
                                                }


                                            </>
                                        } />
                                </div>

                                <div className="time">
                                    <h2>Time*</h2>
                                    <Controller
                                        name="time"
                                        control={control}
                                        rules={{
                                            required: "Please select start time"
                                        }}
                                        render={({ field }) =>
                                            <>
                                                <div className="input-image">
                                                    <input
                                                        type="time"
                                                        name='time'
                                                        placeholder='hh:mm'
                                                        {...field}
                                                        value={moment(field.value, ["h:mm A"]).format("HH:mm")}
                                                        // value={field.value}
                                                        required
                                                    />
                                                    <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
                                                </div>
                                                {errors?.time?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.time?.message} />
                                                    </div>
                                                }
                                            </>
                                        }
                                    />
                                </div>
                            </div>
                            {/* Reason */}
                            <div className="row-primary">
                                <h2>Reason</h2>
                                <Controller
                                    name="reschedule_reason"
                                    control={control}
                                    rules={{
                                        required: "Please write reason"
                                    }}
                                    render={({ field }) =>
                                        <>
                                            <textarea
                                                className="type_inp input-in"
                                                {...field}
                                                placeholder='Please enter notes for Re-Scheduled ...'
                                                required
                                            >
                                            </textarea>

                                            {errors?.reschedule_reason?.message && (
                                                <ErrorMessage
                                                    text={errors?.reschedule_reason?.message}
                                                />
                                            )}
                                        </>
                                    }

                                />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <SubmitButton buttonType="submit" className={'lightBlue'} btnText="Re-Schedule" loader={isLoading} />
                        <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                    </ModalFooter>
                </form>
            </Modal>

        </>
    );
}

export default RescheduleModal;